var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec1Icon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec1Icon1",
    transform: "translate(-552 -818)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1113",
    "data-name": "\\uD0C0\\uC6D0 1113",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(552 818)",
    fill: "#eaf8fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "translate(566.437 833.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33829",
    "data-name": "\\uD328\\uC2A4 33829",
    d: "M2.284,103.426H30.842a2.285,2.285,0,0,1,2.285,2.284v20.561a2.285,2.285,0,0,1-2.285,2.284H2.284A2.285,2.285,0,0,1,0,126.272V105.71A2.285,2.285,0,0,1,2.284,103.426Zm0,0",
    transform: "translate(0 -97.566)",
    fill: "#75462e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33830",
    "data-name": "\\uD328\\uC2A4 33830",
    d: "M70.356,103.426H69.89l-28.062,25.13H70.356a2.285,2.285,0,0,0,2.285-2.284V105.71A2.285,2.285,0,0,0,70.356,103.426Zm0,0",
    transform: "translate(-39.515 -97.566)",
    fill: "#6e422b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33831",
    "data-name": "\\uD328\\uC2A4 33831",
    d: "M196.223,2.433V5.86h2.285V2.433h6.854V5.86h2.284V2.433A2.285,2.285,0,0,0,205.361.148h-6.854A2.285,2.285,0,0,0,196.223,2.433Zm0,0",
    transform: "translate(-185.371)",
    fill: "#6b402a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33832",
    "data-name": "\\uD328\\uC2A4 33832",
    d: "M33.126,142.973l-14.279,6.282H14.279L0,142.973v-6.282a2.285,2.285,0,0,1,2.284-2.285H30.842a2.285,2.285,0,0,1,2.285,2.285Zm0,0",
    transform: "translate(0 -126.833)",
    fill: "#663d28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33833",
    "data-name": "\\uD328\\uC2A4 33833",
    d: "M33.126,111.993l-14.279,6.282H14.279L0,111.993V105.71a2.285,2.285,0,0,1,2.284-2.284H30.842a2.285,2.285,0,0,1,2.285,2.284Zm0,0",
    transform: "translate(0 -97.566)",
    fill: "#875339"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33834",
    "data-name": "\\uD328\\uC2A4 33834",
    d: "M196.223,82.77h2.285v1.142h-2.285Zm0,0",
    transform: "translate(-185.371 -78.052)",
    fill: "#5c3724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33835",
    "data-name": "\\uD328\\uC2A4 33835",
    d: "M361.465,82.77h2.284v1.142h-2.284Zm0,0",
    transform: "translate(-341.475 -78.052)",
    fill: "#5c3724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33836",
    "data-name": "\\uD328\\uC2A4 33836",
    d: "M195.724,103.426h-6.093l-15.1,12.815,4.626,2.035h4.569l14.279-6.282V105.71A2.285,2.285,0,0,0,195.724,103.426Zm0,0",
    transform: "translate(-164.883 -97.566)",
    fill: "#7d4a32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33837",
    "data-name": "\\uD328\\uC2A4 33837",
    d: "M258.191,371.941h4.569v2.284a2.285,2.285,0,1,1-4.569,0Zm0,0",
    transform: "translate(-243.912 -351.231)",
    fill: "#ffa230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33838",
    "data-name": "\\uD328\\uC2A4 33838",
    d: "M289.172,402.922h1.142v1.142h-1.142Zm0,0",
    transform: "translate(-273.18 -380.499)",
    fill: "#fdb62f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33839",
    "data-name": "\\uD328\\uC2A4 33839",
    d: "M258.191,330.629h4.569v2.285h-4.569Zm0,0",
    transform: "translate(-243.912 -312.204)",
    fill: "#ffa230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33840",
    "data-name": "\\uD328\\uC2A4 33840",
    d: "M258.191,330.629h4.569v1.142h-4.569Zm0,0",
    transform: "translate(-243.912 -312.204)",
    fill: "#fdb62f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33841",
    "data-name": "\\uD328\\uC2A4 33841",
    d: "M258.191,371.941h4.569v1.142h-4.569Zm0,0",
    transform: "translate(-243.912 -351.231)",
    fill: "#f0890c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec1Icon1);
export default __webpack_public_path__ + "static/media/sec1Icon1.084f7db702d02ca09a7e2bb8b11dc0b5.svg";
export { ForwardRef as ReactComponent };